import React, { useEffect, useState } from 'react';
import './Community.css';
import Discussion from './Tabs/Discussion';
import PollTab from './Tabs/Poll';
import { Link } from 'react-router-dom';
import { useModuleContext } from '../../context/ModuleProvider';
import { FiMessageSquare, FiBarChart2 } from 'react-icons/fi';
import { PiRss } from 'react-icons/pi';
import Newsfeed from '../News/Newsfeed';
import axiosInstance from '../../axiosapi';
import ExploreTap from '../Discussion/Main/ExploreTap';
import Support from '../Discussion/Support/Support';
import PremiumAccessPage from '../ui/PremiumAccessPage/PremiumAccessPage';

const Community = () => {
  let { moduleId, url, isExpired } = useModuleContext();
  const [activeTab, setActiveTab] = useState('explore');
  const [subject, setSubject] = useState(null);
  const [achievers, setAchievers] = useState(null);
  const showByType = moduleId === 'pg' || moduleId === 'nmcle';

  const [search, setSearch] = useState('');

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tabFromUrl = params.get('tab');
    if (tabFromUrl) {
      setActiveTab(tabFromUrl);
    } else {
      params.set('tab', 'explore');
      window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
    }
  }, []);

  const getAchivers = () => {
    axiosInstance({
      method: 'get',
      url: `${url}/poll/achievers`,
    }).then((res) => {
      setAchievers(res.data.achievers);
    });
  };

  useEffect(() => {
    axiosInstance({
      method: 'get',
      url: `${url}/poll/subject${showByType ? '/type' : ''}`,
    }).then((res) => {
      setSubject(res.data.subject);
    });
    getAchivers();
  }, []);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const params = new URLSearchParams(window.location.search);
    params.set('tab', tab);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    window.history.replaceState({}, '', newUrl);
  };

  return (
    <div className="community-container mx-2 bg-white">
      <div className="community-header pb-3">
        <div>
          <h2>Community</h2>
          <p className="muted-text">Connect, discuss, and learn with your peers</p>
        </div>

        {!isExpired() && (
          <>
            {(activeTab === 'discussion' || activeTab === 'poll') && (
              <Link to={`/${moduleId}/discussion/add?tab=${activeTab}`} className="d-flex justify-content-center">
                <button className="primary-button">
                  <span className="icon">
                    <span className="" style={{ fontWeight: 'bold' }}>
                      ＋
                    </span>
                  </span>
                  <div>{activeTab === 'discussion' ? 'Start Discussion' : 'Start Poll'}</div>
                </button>
              </Link>
            )}
          </>
        )}
      </div>

      {isExpired() ? (
        <PremiumAccessPage />
      ) : (
        <div className="community-grid">
          <div className="col-12 col-sm-8">
            <ul className="tab-list">
              <li>
                <button
                  className={`tab-button ${activeTab === 'explore' ? 'active' : ''}`}
                  onClick={() => handleTabChange('explore')}
                >
                  <FiMessageSquare />
                  <span> Explore</span>
                </button>
              </li>
              <li>
                <button
                  className={`tab-button ${activeTab === 'discussion' ? 'active' : ''}`}
                  onClick={() => handleTabChange('discussion')}
                >
                  <FiMessageSquare />
                  <span> Discussions</span>
                </button>
              </li>
              <li>
                <button
                  className={`tab-button ${activeTab === 'news' ? 'active' : ''}`}
                  onClick={() => handleTabChange('news')}
                >
                  <PiRss />
                  <span className="news">News Feed</span>
                </button>
              </li>
              <li>
                <button
                  className={`tab-button ${activeTab === 'poll' ? 'active' : ''}`}
                  onClick={() => handleTabChange('poll')}
                >
                  <FiBarChart2 />
                  <span>Polls</span>
                </button>
              </li>
              <li>
                <button
                  className={`tab-button ${activeTab === 'support' ? 'active' : ''}`}
                  onClick={() => handleTabChange('support')}
                >
                  <FiBarChart2 />
                  <span>Support</span>
                </button>
              </li>
            </ul>

            <div className="tab-content">
              {activeTab === 'explore' && (
                <div>
                  <div className=" ">
                    <ExploreTap moduleId={moduleId} achievers={achievers} subject={subject} />
                  </div>
                </div>
              )}

              {activeTab === 'discussion' && <Discussion />}
              {activeTab === 'news' && (
                <div>
                  <input
                    type="text"
                    className="input"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Search news..."
                  />
                  <Newsfeed search={search} />
                </div>
              )}
              {activeTab === 'poll' && (
                <div>
                  <div className="align-end"></div>
                  <div className="info-box-discussion">
                    <PollTab />
                  </div>
                </div>
              )}
              {activeTab === 'support' && (
                <div>
                  <div className="align-end"></div>
                  <div className="info-box-support">
                    <Support moduleId={moduleId} />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="guidelines-card">
            <div className="card-header-content">
              <p>Community Guidelines</p>
            </div>
            <div className="card-body-content">
              <p>
                Please be respectful and supportive toward all members. Keep conversations focused and relevant to the
                topic. Avoid sharing answers to ongoing tests or assignments. If you see inappropriate content, report
                it to the moderators.
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Community;
